import t from "../translations";

const BackEndLearnArray = () => t.backEndTopics;

export default BackEndLearnArray;
